import { CTABannerRefProjection } from '../references/CTABannerRef.query';

export const queryBase = groq`*[_type == 'base' && currentPathname == $currentPathname][0]{
  ...,
  CTABanner {
    reference-> ${CTABannerRefProjection}
  }
}`;
